const appConfig = {
  ANALYTICS: {
    mindBox: {
      enabled: process.env.REACT_APP_ENVIRONMENT === 'production',
    },
  },
};

export default appConfig;
